import {
  ActivityIcon,
  HeartIcon,
  MeditationIcon,
  MetabolicHealthWaveIcon,
  MoonIcon,
  StressIcon,
} from '@jouzen/ecom-components';

import type { TextColProps } from '@/app/components/TwoColumnModule';

export const motionProps = {
  initial: { filter: 'blur(5px)', opacity: 0 },
  style: { height: '100%' },
  transition: { delay: 0.5, duration: 0.5 },
  viewport: { once: true },
  whileInView: { filter: 'blur(0px)', opacity: 1 },
};

const textClassName =
  'text-sm lg:text-base flex w-full h-full justify-center items-center';
const iconClassName =
  'bg-sandstone-400 lg:p-4 p-2 rounded-full text-sandstone-500';
export const textCol: TextColProps = {
  titleProps: {
    label: 'ring_pdp_2025_membership_section_copy',
    className: 'mb-6 lg:mb-8 text-base',
    Element: 'h5',
    height: 'tight',
    variant: 'body-large',
  },
  textColClassName:
    'flex-start flex flex-row flex-wrap justify-between gap-y-6 pt-4 md:pt-2',
  iconSize: 24,
  iconTextContainerClassName:
    'flex flex-row xl:basis-[256px] lg:basis-[200px] md:basis-[156px] basis-[120px] gap-y-4 md:gap-x-4 gap-x-2',
  paragraphs: [
    {
      icon: HeartIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_1',
        className: textClassName,
      },
    },
    {
      icon: MoonIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_2',
        className: textClassName,
      },
    },
    {
      icon: ActivityIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_3',
        className: textClassName,
      },
    },
    {
      icon: MeditationIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_4',
        className: textClassName,
      },
    },
    {
      icon: StressIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_5',
        className: textClassName,
      },
    },
    {
      icon: MetabolicHealthWaveIcon,
      iconClassName,
      textProps: {
        label: 'ring_pdp_2025_membership_section_highlight_6',
        className: textClassName,
      },
    },
  ],
};
